import Styles from "./NewDocument.module.scss";
import { useLocation } from "react-router-dom";
import clsx from "clsx";

import MenuVTC from "../../../Share/Component/MenuVtc";
const docs = [
  {
    Id: "1",
    Title: "KNB , phát triển xây dựng máy chủ bền lâu - 1",
    Src: "https://docs.google.com/document/d/e/2PACX-1vRjdwiVHMaAvnDf-f4P9Ec4bRXizBqdeNs07Iomi-5xTEL_hQrtIAG84rwgAOF2W8Rv67KfV16lSe-U/pub?embedded=true",
  },
  {
    Id: "2",
    Title: "KNB , phát triển xây dựng máy chủ bền lâu - 2",
    Src: "https://docs.google.com/document/d/e/2PACX-1vRjdwiVHMaAvnDf-f4P9Ec4bRXizBqdeNs07Iomi-5xTEL_hQrtIAG84rwgAOF2W8Rv67KfV16lSe-U/pub?embedded=true",
  },
  {
    Id: "3",
    Title: "KNB , phát triển xây dựng máy chủ bền lâu - 3",
    Src: "https://docs.google.com/document/d/e/2PACX-1vRjdwiVHMaAvnDf-f4P9Ec4bRXizBqdeNs07Iomi-5xTEL_hQrtIAG84rwgAOF2W8Rv67KfV16lSe-U/pub?embedded=true",
  },
  {
    Id: "4",
    Title: "KNB , phát triển xây dựng máy chủ bền lâu - 4",
    Src: "https://docs.google.com/document/d/e/2PACX-1vRjdwiVHMaAvnDf-f4P9Ec4bRXizBqdeNs07Iomi-5xTEL_hQrtIAG84rwgAOF2W8Rv67KfV16lSe-U/pub?embedded=true",
  },
];

function NewDocument() {
  const location = useLocation();
  const pathnameArr = location.pathname.split("/:id");
  const ID = pathnameArr.pop();

  return (
    <div style={{ backgroundColor: "#000" }}>
      <div className={clsx(Styles.wrapper)}>
        <div className={clsx(Styles.wrapperInner)}>
          <div className={clsx(Styles.contentMain)}>
            <div className={clsx(Styles.detailContent)}>
              {ID - 1 >= 0 && ID - 1 < docs.length ? (
                <>
                  <div className={clsx(Styles.head)}>
                    <h3 style={{ textAlign: "center" }}>
                      {docs[ID - 1].Title}
                    </h3>
                  </div>
                  <div className={clsx(Styles.body)}>
                    {/* Adding document */}
                    <div className={clsx(Styles.containerIframe)}>
                      <iframe
                        title="document"
                        className={clsx(Styles.iframe)}
                        src={docs[ID - 1].Src}
                      ></iframe>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className={clsx(Styles.head)}>
                    <h3 style={{ textAlign: "center" }}>{""}</h3>
                  </div>
                  <div className={clsx(Styles.body)}>
                    <div>No content found</div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <MenuVTC />
    </div>
  );
}
export default NewDocument;
